<template>
  <div class="box">
    <div class="home">
      <div class="home-left">
        <div class="home-left-top">
          <Titles :title="'待办任务'"></Titles>
          <homeleFttop></homeleFttop>

        </div>
        <div class="home-left-centre">
           <Titles :title="'示范社统计'"></Titles>
           <homeleFtcentre></homeleFtcentre>
           </div>
        <div class="home-left-bottom">
          <Titles :title="'合作社成员统计'"></Titles>
          <homeleFtbottom  :source="this.allCityTypeList.data"
           :legend="allCityTypeList.legend"
           :radius="[50, 70]"></homeleFtbottom>
        </div>
      </div>
      <div class="home-centre">
        <div class="home-centre-top">
          <!-- <Title :title="'字标'"></Title> -->
          <homeCentretop></homeCentretop>
          </div>
        <div class="home-centre-middle">
          <!-- <Titles :title="'地图'"></Titles> -->
          <homeCentreMiddle></homeCentreMiddle>
          </div>
        <div class="home-centre-bottom">
          <Titles :title="'政策资讯'"></Titles>
          <homeCenterBottom></homeCenterBottom>
        </div>
      </div>
      <div class="home-right">
        <div class="home-right-top">
          <Titles :title="'主体类型统计'"></Titles>
          <homeRighttop
          :zydhCount="depmentObjRadio.zydhCount"
          :jtncCount="depmentObjRadio.jtncCount"
          :hzsCount="depmentObjRadio.hzsCount"
          :ltqyCount="depmentObjRadio.ltqyCount"
          :series="depmentObjRadio.series"
          :titleList="depmentObjRadio.title"
          :source2="allCityTypeList2.data"
          :legend2="allCityTypeList2.legend"
          :radius2="[50, 65]"></homeRighttop>
          </div>
        <div class="home-right-center">
          <Titles :title="'经营类型统计'"></Titles>
          <homeRightCenter :source="bottomHistogram.data"  :dataList="dataList" :titleList="bottomHistogram.title"></homeRightCenter>
        </div>
        <div class="home-right-bottom">
          <Titles :title="'托管服务'"></Titles>
          <homeRightBottom></homeRightBottom>
        </div>
      </div>
    </div>
    <div class="font">Copyright◎北京世纪国源科技股份有限公司版权所有</div>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import Titles from "./title.vue";
import homeleFttop from './homelefttop.vue'
import homeleFtcentre from './homeleftcentre.vue'
import homeleFtbottom from './homeleftbottom.vue'
import homeCentretop from './homecentretop.vue'
import homeCentreMiddle from './homecentremiddle.vue'
import homeRighttop from './homerighttop.vue'
import homeRightCenter from './homerightcenter.vue'
import homeRightBottom from './homerightbottom'
import homeCenterBottom from './homecenterbottom'
import API from "@/api/serviceOrgManagement/api_userManagement";
export default {
  components: {
    Titles,
    homeleFttop,
    homeleFtcentre,
    homeleFtbottom,
    homeCentretop,
    homeCentreMiddle,
    homeRighttop,
    homeRightCenter,
    homeRightBottom,
    homeCenterBottom
  },
  data() {
    return {
      activeName: "first",
      qhdm: Cookies.get('areacode'),
      allCityTypeList:{
        legend:[ '普通农户', '家庭农场成员', '企业成员','其他成员'],
        data:null,
      },
      allCityTypeList:{
        legend:[ '普通农户', '家庭农场成员', '企业成员','其他成员'],
        data:null,
      },
      depmentObjRadio:{
        title:null,
        hzsCount:null,
        jtncCount:null,
        zydhCount:null,
        ltqyCount:null,

        series:[{type: 'bar',}],
      },
      bottomHistogram:{
        title:null,
        data:null,
        series:[{type: 'bar',}],
      },
      allCityTypeList2:{
        legend:[ '合作社', '家庭农场', '龙头企业','种植大户'],
        data:null,
      },
      dataCount:{},
      dataList:[],
      EnterpriseType:[]
    };

  },
  created() {
    this.GLOBAL.eventBus.$on("refresh_big_screen_info",this.queryData);
  },
  mounted(){
    this.enterpriseStatMembers()
    // this.enterpriseStatEnterpriseMap()
     this.getstatIndustry()
    // this.enterpriseStatMembersFn()
    this.enterpriseStatEnterpriseType()
  },
  methods: {
    queryData(qhdm){
      this.qhdm = qhdm;
      this.enterpriseStatMembers()
      // this.enterpriseStatEnterpriseMap()
       this.getstatIndustry()
      // this.enterpriseStatMembersFn()
      this.enterpriseStatEnterpriseType()

    },
    async enterpriseStatMembers() {
      const { code, data } = await API.enterpriseStatMembers({qhdm: this.qhdm});
      if (code === 0) {
        this.dataCount = data.count;
        this.enterpriseStatMembersFn()
      }
    },
    enterpriseStatMembersFn(){
      var data ={
          farmerCount	: '普通农户',
          familyMemberCount: '家庭农场成员',
          enterpriseMemberCount: '企业成员',
          otherMemberCount: '其他成员',
        }
      this.allCityTypeList.data  = this.formatedata(data, this.dataCount);
    },
    //获取经营类型统计
   async getstatIndustry(){
       const { code, data } = await API.statIndustry({qhdm: this.qhdm});
        if (code === 0) {
         this.dataList = data.list;
         this.enterpriseStatEnterpriseMapFn(this.dataList)

      }
    },
    //暂时不要了
    async enterpriseStatEnterpriseMap(){
      const { code, data } = await API.enterpriseStatType({qhdm: this.qhdm});
      if (code === 0) {
        this.dataList = data.list;
        console.log("获取信息",this.dataList)
        this.enterpriseStatEnterpriseMapFn(this.dataList)
      }
    },
    enterpriseStatEnterpriseMapFn(val){
        const data = val
        const list = [];
        const title = [];
        data.forEach(element => {
          title.push(element.key);
          list.push(element.value);
        });
        list.reverse()
        title.reverse()
      this.bottomHistogram.title = [...JSON.parse(JSON.stringify(title))];
      this.bottomHistogram.data = [...JSON.parse(JSON.stringify(list))];
    },
    async enterpriseStatEnterpriseType(){
      const { code, data } = await API.enterpriseStatEnterpriseType({qhdm: this.qhdm});
      if (code === 0) {
        this.EnterpriseType = data;
        this.rightEnterpriseMapFn()
        this.enterpriseStatMembers2()
      }
    },
    //右侧柱状图
    rightEnterpriseMapFn(){
        const data = this.EnterpriseType.list;
        const jtncCount = [];//农场
        const titles = [];
        const hzsCount = [];//合作社
        const zydhCount = [];
        const ltqyCount = [];//合作社
        data.forEach(element => {
          titles.push(element.qhmc);
          jtncCount.push(element.jtncCount);
          hzsCount.push(element.hzsCount)
          zydhCount.push(element.zydhCount);
          ltqyCount.push(element.ltqyCount)
        });
        this.depmentObjRadio.title = [...JSON.parse(JSON.stringify(titles))];
        this.depmentObjRadio.jtncCount = [...JSON.parse(JSON.stringify(jtncCount))];
        this.depmentObjRadio.hzsCount = [...JSON.parse(JSON.stringify(hzsCount))];
        this.depmentObjRadio.ltqyCount = [...JSON.parse(JSON.stringify(ltqyCount))];
        this.depmentObjRadio.zydhCount = [...JSON.parse(JSON.stringify(zydhCount))];
        console.log("this.depmentObjRadio",this.depmentObjRadio)
    },
    enterpriseStatMembers2(){
      var data ={
          hzsCount	: '合作社',
          jtncCount: '家庭农场',
          ltqyCount:'龙头企业',
          zydhCount:'种植大户'
        }
      this.allCityTypeList2.data  = this.formatedata(data, this.EnterpriseType);
    },
     formatedata(obj, data){
      const keys = Object.keys(obj);
      const arr = [];
      keys.forEach(element => {
        const ob = {
          value: data[element],
          name: obj[element]
        }
        arr.push(ob);
      });
      return arr;
    },
  }
};
</script>

<style lang="less" scoped>
.box{
  width: 100%;
  height: 100%;
}
.home {
  display: flex;
  width: 100%;
  height: 100%;
  color: #fff;
  // height: 100%;
  // padding: 20px 0px 20px 20px;
}
.home-left {
  width: 25%;
  margin-right: 12px;
  display: flex;
  flex-direction: column;
  .home-left-top {
    width: 100%;
    height: 19%;
    margin-bottom: 20px;
    // background: #ffffff;
    // box-shadow: 0px 0px 18px 0px rgba(18, 29, 54, 0.07);
    // border-radius: 10px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .home-left-centre {
    width: 100%;
    flex-grow: 1;
    margin-bottom: 20px;
    // background: #ffffff;
    // box-shadow: 0px 0px 18px 0px rgba(18, 29, 54, 0.07);
    // border-radius: 8px;
    flex-shrink: 0;
  }
  .home-left-bottom {
    width: 100%;
    height: 30%;
    // width: 406px;
    flex-shrink: 0;
    // height: 50%;
    // background: #ffffff;
    // box-shadow: 0px 0px 18px 0px rgba(18, 29, 54, 0.07);
    // border-radius: 8px;
  }
}
.home-centre {
  width: 50%;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  .home-centre-top {
    width: 100%;
    flex-shrink: 0;
    // height: 18%;
    height: 10%;
    // background: #ffffff;
    // box-shadow: 0px 0px 18px 0px rgba(18, 29, 54, 0.07);
    // border-radius: 8px;
    margin-bottom: 20px;
  }
  .home-centre-middle {
    width: 100%;
    flex-shrink: 0;
    flex-grow: 1;
    // height: calc(81% - 60px);
    // height: 0%;
    // background: #ffffff;
    // box-shadow: 0px 0px 18px 0px rgba(18, 29, 54, 0.07);
    // border-radius: 8px;
  }

  .home-centre-bottom {
    width: 100%;
    flex-shrink: 0;
    // height: 18%;
    height: 30%;
    // background: #ffffff;
    // box-shadow: 0px 0px 18px 0px rgba(18, 29, 54, 0.07);
    // border-radius: 8px;
  }
}
.home-right {
  width:25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .home-right-top {
    // height: calc(50% + 20px);
    height: 30%;
    flex-shrink: 0;
    // background: #ffffff;
    // border-radius: 8px;
    margin-bottom: 20px;
  }

  .home-right-center {
    // height: calc(50% + 20px);
    flex-shrink: 0;
    flex-grow: 1;
    // background: #ffffff;
    // border-radius: 8px;
    margin-bottom: 20px;
  }

  .home-right-bottom {
    height: 30%;
    flex-shrink: 0;
  }
}
.font{
  // margin: 0 auto;
  // height: 60px;
  // text-align: center;
  position: absolute;
  bottom: 12px;
  left: 40%;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fff;
  line-height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/index.vue